import Axios from "axios";

class AnmeldungService {

    static storeAnmeldung(veranstaltungId, data) {
        return Axios.post("/api/veranstaltungen/" + veranstaltungId + "/anmeldungen", data);
    }

    static excel2Anmeldungen(file) {
        const formData = new FormData();
        formData.append("file", file);

        return Axios.post("/api/comfort/excel2anmeldungen", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

}

export default AnmeldungService;


// WEBPACK FOOTER //
// ./src/services/AnmeldungService.js